// Dynamically preload the main product image on the current page
document.addEventListener('DOMContentLoaded', () => {
    // Find the container element
    const containerElement = document.querySelector('DIV.image__container');

    if (containerElement) {
        // Find the main image element inside the container
        const mainProductImage = containerElement.querySelector('IMG.product-gallery__image.appear'); // Using a more specific selector based on your element

        if (mainProductImage && mainProductImage.src) {
            const imageUrl = mainProductImage.src;

            // Create a new link element for preloading
            const preloadLink = document.createElement('link');
            preloadLink.rel = 'preload';
            preloadLink.as = 'image';
            preloadLink.href = imageUrl;
            preloadLink.fetchPriority = 'high'; // Optional, but recommended for critical images

            // Check if a similar preload link already exists to avoid duplicates
            // This check is basic; a more robust check might be needed depending on your setup
            const existingPreloadLink = document.querySelector(`link[rel="preload"][href="${imageUrl}"]`);
            if (!existingPreloadLink) {
                 // Append the preload link to the document's head
                document.head.appendChild(preloadLink);
                console.log(`Dynamically preloaded: ${imageUrl}`); // Optional: for debugging
            } else {
                 console.log(`Preload link for ${imageUrl} already exists.`); // Optional: for debugging
            }
        } else {
            console.log('Main product image not found within the container.'); // Optional: for debugging
        }
    } else {
         console.log('Image container element not found.'); // Optional: for debugging
    }
});
